import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import IFeedback from "../interfaces/IFeedback";

enum FeedbackServiceEnum {
  byRecaptchaToken = "?recaptcha=",
  getFeedbackByTradeId = "?tradeId=",
  getFeedbacks = "/"
}

export default class FeedbackService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/feedbacks");
  }

  public postByRecaptchaToken = async (token: string, data: IFeedback): Promise<any> => await this.POST(FeedbackServiceEnum.byRecaptchaToken + token, data);
  public getFeedbacksByTradeId = async (tradeId: number) => await this.GET(FeedbackServiceEnum.getFeedbackByTradeId + tradeId);
  public getFeedbacks = async () => (await this.GET(FeedbackServiceEnum.getFeedbacks)).data;
}



// WEBPACK FOOTER //
// ./src/services/api/Feedback.service.ts